import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const AuthContext = createContext();

const TOKEN_KEY = 'nordic_auth_token';
const BOOKER_KEY = 'nordic_auth_booker';

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [booker, setBooker] = useState(() => {
    const stored = localStorage.getItem(BOOKER_KEY);
    return stored ? JSON.parse(stored) : null;
  });

  const isAuthenticated = !!token && !!booker;
  const isAdmin = !!booker?.isAdmin;

  const login = useCallback((newToken, newBooker) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    localStorage.setItem(BOOKER_KEY, JSON.stringify(newBooker));
    setToken(newToken);
    setBooker(newBooker);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(BOOKER_KEY);
    setToken(null);
    setBooker(null);
  }, []);

  // Check token expiry on mount (JWT exp claim)
  useEffect(() => {
    if (!token) return;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp * 1000 < Date.now()) {
        logout();
      }
    } catch {
      logout();
    }
  }, [token, logout]);

  return (
    <AuthContext.Provider value={{ token, booker, isAuthenticated, isAdmin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
